export default __webpack_public_path__ + "static/media/miscellaneous01.c8e92b2a.png";